import { Environment, parseEnvName } from './environment.type';

export const environment: Environment = {
  name: 'RAVEN',
  isProduction: true,
  envName: parseEnvName('Production'),
  showEnv: parseShowEnv('False'),
  hmr: false,
  auth: {
    enabled: true,
    clientId: 'cbf3b65e-3ee8-480a-b434-b2b6a5576520',
  },
  build: {
    tag: '2026.12',
    branchName: 'main',
    buildNumber: '20261026.3',
  },
  appInsights: {
    connectionString: 'InstrumentationKey=1853669e-4214-4256-87f9-a3cfbd47b179;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=da1b9735-1ddc-4911-bb7a-af47f186a5be',
  },
  backend: {
    url: '/api',
  },
  support: {
    mail: {
      to: '',
    },
  },
};

export function parseShowEnv(showEnv: string): boolean {
  return showEnv == 'True';
}
